import { render } from "./HelloWorld.vue?vue&type=template&id=7a7efe52&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7a7efe52"

export default script